import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Avatar,
  Tooltip,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../auth/useAuth";
import { useNavigate, useLocation } from "react-router-dom";

const AppBarHeader = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isUsersPage = location.pathname === "/users";
  const isPublishedPage = location.pathname === "/published";

  return (
    <AppBar
      position="static"
      elevation={1}
      sx={{
        backgroundColor: "#ffffff",
        color: "#002b5c",
        borderBottom: "1px solid #e0e0e0",
        px: 3,
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: 72,
        }}
      >
        {/* LEFT — Logo + App Name + Nav */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <img
            src={process.env.PUBLIC_URL + "/msi.png"}
            alt="MSI Express"
            style={{ height: 44, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#1e40af",
              fontFamily: "Inter, Helvetica, sans-serif",
              letterSpacing: 0.3,
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          >
            Weekly Schedule
          </Typography>

          {/* 👇 Navigation Buttons */}
          <Button
            variant={isUsersPage ? "contained" : "outlined"}
            size="small"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
            }}
            onClick={() => navigate("/users")}
          >
            User Management
          </Button>

          <Button
            variant={isPublishedPage ? "contained" : "outlined"}
            size="small"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
            }}
            onClick={() => navigate("/published")}
          >
            Published Schedules
          </Button>
        </Box>

        {/* RIGHT — User Info */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {user?.name && (
            <Tooltip
              title={user.email}
              arrow
              componentsProps={{
                tooltip: { sx: { fontSize: 12 } },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar
                  sx={{
                    bgcolor: "#1e40af",
                    width: 34,
                    height: 34,
                    fontSize: 15,
                  }}
                >
                  {user.name.charAt(0).toUpperCase()}
                </Avatar>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 500,
                    color: "#002b5c",
                    textTransform: "capitalize",
                  }}
                >
                  {user.name}
                </Typography>
              </Box>
            </Tooltip>
          )}

          {/* Optional logout icon */}
          <Tooltip title="Sign Out" arrow>
            <Button
              color="error"
              startIcon={<LogoutIcon />}
              sx={{
                ml: 2,
                textTransform: "none",
                fontWeight: 600,
              }}
              onClick={signOut}
            >
              Logout
            </Button>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppBarHeader;
